import { Action } from "@ngrx/store";
import { Card, Section } from "@edp-models/benefits.model";
import { IUserEfficiency } from "@edp-models/energy-efficiency.model";
import { UserParticipation } from "@edp-models/edp-campaigns.model";
import { MgmCode } from "@edp-models/edpe-mgm";

export enum EEdpeActions {
    SetDashboardCards               = "Set Dashboard Cards",
    SetDashboardGeneratedCodeCards  = "Set Dashboard Generated Codes Cards",
    SetShowAlert                    = "Set Show Alert",
    GetShowAlert                    = "Get Show Alert",
    GetUserEfficiency               = "[Edpe] Get User Efficiency",
    SetUserEfficiency               = "[Edpe] Set User Efficiency",
    GetDashboardSections            = "Get Sections",
    SetDashboardSections            = "Set Sections",
    SetLoadedDashboard              = "Set Loaded Dashboard",
    ShowMacroChallengeModal         = "Show Macro Challenge Modal",
    SetMacroChallengeSubscription   = "[Edpe] Set Macro Challenge Subscription",
    GetUserAvailableParishList      = "[Edpe] Get User Available Parish List",
    SetUserAvailableParishList      = "[Edpe] Set User Available Parish List",
    GetUserParticipation            = "[Edpe] Get user participation",
    SetUserParticipation            = "[Edpe] Set user participation",
    InsertUserParticipation         = "[Edpe] Insert User Participation",
    ShareToEarn                     = "[Edpe] Share to Earn zs",
    GetUserPoints                   = "[Edpe] Get User Points",
    GetMgmCode                      = "[Edpe] Get Mgm Code",
    SetMgmCode                      = "[Edpe] Set Mgm Code",
    ValidateMgmCode                 = "[Edpe] Validate Mgm Code",
    SendShareEmail                  = "[Edpe] Send Share Email",
    SendShareSocial                 = "[Edpe] Send Share Social",
    UpdateMgmAlert                  = "[Edpe] Update Mgm Alert",
    GetQuizzs                       = "[Edpe] Get Quizzs",
    SetQuizzs                       = "[Edpe] Set Quizzs"
}

export class SetDashboardCards implements Action {
    public readonly type = EEdpeActions.SetDashboardCards;
    constructor(public payload: Card[]) {}
}

export class SetDashboardGeneratedCodeCards implements Action {
    public readonly type = EEdpeActions.SetDashboardGeneratedCodeCards;
    constructor(public payload: Card[]) {}
}

export class GetShowAlert implements Action {
    public readonly type = EEdpeActions.GetShowAlert;
    }
export class SetShowAlert implements Action {
    public readonly type = EEdpeActions.SetShowAlert;
    constructor(public payload: boolean) {}
}

export class GetUserEfficiency implements Action {
    public readonly type = EEdpeActions.GetUserEfficiency;
    }

export class SetUserEfficiency implements Action {
    public readonly type = EEdpeActions.SetUserEfficiency;
    constructor(public payload: IUserEfficiency) {}
}

export class GetDashboardSections implements Action {
    public readonly type = EEdpeActions.GetDashboardSections;
    }

export class SetDashboardSections implements Action {
    public readonly type = EEdpeActions.SetDashboardSections;
    constructor(public payload: Section[]) {}
}

export class ShowMacroChallengeModal implements Action {
    public readonly type = EEdpeActions.ShowMacroChallengeModal;
    constructor(public section: Section) {}
}

export class SetLoadedDashboard implements Action {
    public readonly type = EEdpeActions.SetLoadedDashboard;
    constructor(public payload: boolean) {}
}

export class SetMacroChallengeSubscription implements Action {
    public readonly type = EEdpeActions.SetMacroChallengeSubscription;
    constructor(public payload: {}) {}
}

export class GetUserParticipation implements Action {
    public readonly type = EEdpeActions.GetUserParticipation;
    constructor() {}
}

export class SetUserParticipation implements Action {
    public readonly type = EEdpeActions.SetUserParticipation;
    constructor(public payload: UserParticipation) {}
}

export class GetUserAvailableParishList implements Action {
    public readonly type = EEdpeActions.GetUserAvailableParishList;
    constructor() {}
}

export class SetUserAvailableParishList implements Action {
    public readonly type = EEdpeActions.SetUserAvailableParishList;
    constructor(public payload: any) {}
}

export class InsertUserParticipation implements Action {
    public readonly type = EEdpeActions.InsertUserParticipation;
    constructor(public payload: any) {}
}

export class ShareToEarn implements Action {
    public readonly type = EEdpeActions.ShareToEarn;
    constructor(public payload: any) {}
}

export class GetUserPoints implements Action {
    public readonly type = EEdpeActions.GetUserPoints;
    constructor() {}
}

export class GetMgmCode implements Action {
    public readonly type = EEdpeActions.GetMgmCode;
    constructor() {}
}

export class SetMgmCode implements Action {
    public readonly type = EEdpeActions.SetMgmCode;
    constructor(public payload: MgmCode) {}
}

export class ValidateMgmCode implements Action {
    public readonly type = EEdpeActions.ValidateMgmCode;
    constructor(public payload: any) {}
}

export class SendShareEmail implements Action {
    public readonly type = EEdpeActions.SendShareEmail;
    constructor(public payload: any) {}
}

export class SendShareSocial implements Action {
    public readonly type = EEdpeActions.SendShareSocial;
    constructor(public payload: any) {}
}

export class UpdateMgmAlert implements Action {
    public readonly type = EEdpeActions.UpdateMgmAlert;
    constructor(public payload: any) {}
}

export class GetQuizzs implements Action {
    public readonly type = EEdpeActions.GetQuizzs;
    constructor() {}
}

export class SetQuizzs implements Action {
    public readonly type = EEdpeActions.SetQuizzs;
    constructor(public payload: any) {}
}

export type EdpeActions = SetDashboardCards
                        | SetDashboardGeneratedCodeCards
                        | GetShowAlert
                        | SetShowAlert
                        | GetUserEfficiency
                        | SetUserEfficiency
                        | GetDashboardSections
                        | SetDashboardSections
                        | SetLoadedDashboard
                        | ShowMacroChallengeModal
                        | SetMacroChallengeSubscription
                        | GetUserAvailableParishList
                        | SetUserAvailableParishList
                        | GetUserParticipation
                        | SetUserParticipation
                        | InsertUserParticipation
                        | ShareToEarn
                        | GetUserPoints
                        | GetMgmCode
                        | SetMgmCode
                        | ValidateMgmCode
                        | SendShareEmail
                        | UpdateMgmAlert
                        | SendShareSocial
                        | GetQuizzs
                        | SetQuizzs;
